import { Builder } from 'builder-pattern';
import { ProductPagePropsAll } from '../../src/components/public/ProductPage/ProductPage.types';
import AdelaideRivieraHotelStay, { StayContentMock_2 } from './stayContentFactory';
import dayjs from 'dayjs';

const AuroraFactory = () =>
  Builder<ProductPagePropsAll>()
    .productContent(AdelaideRivieraHotelStay({}))
    .productId('4005623')
    .startDate(dayjs().add(1, 'month').format('YYYY-MM-DD'))
    .nights(5)
    .adults(2)
    .originParam('SYD')
    .destinationParam('BNE')
    .build();

const AuroraFactory2 = () =>
  Builder<ProductPagePropsAll>()
    .productContent(StayContentMock_2)
    .productId('16977785')
    .startDate(dayjs().add(1, 'month').format('YYYY-MM-DD'))
    .nights(5)
    .adults(2)
    .destinationParam('BNE')
    .build();

const AuroraFactory3 = () =>
  Builder<ProductPagePropsAll>()
    .productContent(StayContentMock_2)
    .productId('16977785')
    .adults(2)
    .originParam('SYD')
    .destinationParam('BNE')
    .build();

export default AuroraFactory;
export { AuroraFactory2, AuroraFactory3 };
